export const marchAbbreviatedLowercase = "iqa";
export default {marchAbbreviatedLowercase};